module.exports = __webpack_public_path__ + "static/media/patrol(5).505487a5.PNG";